{
  "version": 1,
  "asset_id": "6d802762-a3c7-4d41-b922-888355697e23",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/6d802762-a3c7-4d41-b922-888355697e23/g13.png",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/6d802762-a3c7-4d41-b922-888355697e23/g13.png",
  "original_filename": "g13.png",
  "size": 175582,
  "content_type": "image/png",
  "created_at": "2026-07-02T22:52:58Z"
}
